function applyAttributes() {
  $('.cbb-also-bought-prev, .cbb-also-bought-next').attr({
    tabindex: '-1',
    'aria-hidden': 'true'
  });
}

(function ($) {

  function throttle(func, limit) {
    let inThrottle;
    return function () {
      if (!inThrottle) {
        func.apply(this, arguments);
        inThrottle = true;
        setTimeout(() => { inThrottle = false; }, limit);
      }
    };
  }

  $(function () {

    (function () {
      var $header = $('.site-header');
      if (!$header.length) return;

      var $offsetTarget = $('main').first();
      if (!$offsetTarget.length) {
        $offsetTarget = $('body');
      }

      var isStuck = false;
      var lastScroll = window.pageYOffset || window.scrollY || 0;
      var delta = 10;

      function setOffset(enabled) {
        if (!$offsetTarget.length) return;
        if (enabled) {
          var headerHeight = $header.outerHeight() || 0;
          $offsetTarget.css('padding-top', headerHeight + 'px');
        } else {
          $offsetTarget.css('padding-top', '');
        }
      }

      $(window).on('scroll.headerSticky', throttle(function () {
        var currentScroll = window.pageYOffset || window.scrollY || $(this).scrollTop();
        var scrollDifference = Math.abs(currentScroll - lastScroll);

        if (scrollDifference < delta) return;

        if (currentScroll < 150) {
          if (isStuck) {
            $header.removeClass('header-stuck header-hidden');
            setOffset(false);
            isStuck = false;
          }
          lastScroll = currentScroll;
          return;
        }

        if (currentScroll < lastScroll) {
          if (!isStuck) {
            $header.addClass('header-stuck');
            setOffset(true);
            isStuck = true;
          }
          $header.removeClass('header-hidden');
        } else {
          if (isStuck) {
            $header.addClass('header-hidden');
          }
        }

        lastScroll = currentScroll;
      }, 50));
    })();

    (function () {
      var checkClProp = setInterval(function () {
        if ($('#CartProducts .cl-prop').length) {
          clearInterval(checkClProp);
          $('.cl-prop a').each(function () {
            var href = $(this).attr('href');
            if (href) {
              $(this).html('<img src="' + href + '" width="100" alt="Custom artwork uploaded — opens enlarge view in new tab.">');
            }
          });
        }
      }, 500);
    })();
    (function () {
      $('#mobile-hit-search').on('click', function () {
        const $search = $('.site-header__search2');

        $search.slideToggle('fast', function () {
          if ($search.is(':visible')) {
            $search.find("input[type='search'], input[type='text']").first().focus();
          }
        });

        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', String(!isExpanded));
      });
    })();

    (function () {
      $("span.meganav__link--second-level:contains('Popular')").prepend(
        '<span aria-hidden="true" class="hot_prod">🔥</span>'
      );

      $('.pagination .page>a').each(function () {
        var pageLabel = $(this).text().trim();
        $(this).attr('aria-label', 'page ' + pageLabel);
      });

      $('.pagination .page.current').each(function () {
        var currentLabel = $(this).text().trim();
        $(this).html('<span class="visually-hidden">current page </span>' + currentLabel);
      });

      $('.pagination .next a').attr('aria-label', 'next page');
      $('.pagination .prev a').attr('aria-label', 'previous page');

      $('.card-title-1').each(function () {
        var titleText = $(this).attr('data-collection');
        if (titleText) {
          $(this).closest('.uniq').attr('id', 'collection-list-grid-' + titleText);
        }
      });
    })();

    (function () {
      var checkCouponBox = setInterval(function () {
        if ($('.wsaio_coupon_box').length) {
          clearInterval(checkCouponBox);
          $('.wsaio_coupon_field > input').attr('aria-label', 'Discount code');
        }
      }, 1000);
    })();

    (function () {
      $('br').attr('aria-hidden', 'true');

      $('a[target="_blank"]').each(function () {
        var link = $(this);
        var href = link.attr('href') || '';
        var domainTPW = /^(https?:\/\/)?(www\.)?theparkwholesale\.com/;

        if (domainTPW.test(href) || href.startsWith('/') || href.startsWith('./') || href.startsWith('../')) {
          link.append('<span class="visually-hidden" style="color:black;background:white;">(This link opens in a new tab)</span>');
        } else {
          link.append('<span class="visually-hidden" style="color:black;background:white;">(This link opens in a new tab)</span>');
        }
      });
    })();

    (function () {
      $('.site-nav__link-toggle')
        .off('click')
        .on('click', function (event) {
          event.stopImmediatePropagation();
          $(this).toggleClass('meganav--active');
          $(this).next('.site-nav__dropdown').toggleClass('meganav--active');

          var isExpanded = $(this).attr('aria-expanded') === 'true';
          $(this).attr('aria-expanded', !isExpanded);

          $(this)
            .closest('.site-nav')
            .find('.site-nav__link-toggle')
            .not(this)
            .each(function () {
              $(this).removeClass('meganav--active');
              $(this).next('.site-nav__dropdown').removeClass('meganav--active');
              $(this).attr('aria-expanded', 'false');
            });
        });

      $(document).keydown(function (event) {
        if (event.keyCode === 27) {
          $('.site-nav__link-toggle').removeClass('meganav--active').attr('aria-expanded', 'false');
          $('.site-nav__dropdown').removeClass('meganav--active');
        }
      });

      $(document).on('click', function (event) {
        if (!$(event.target).closest('.site-nav__link-toggle, .site-nav__dropdown').length) {
          $('.site-nav__link-toggle').removeClass('meganav--active').attr('aria-expanded', 'false');
          $('.site-nav__dropdown').removeClass('meganav--active');
        }
      });
    })();

    (function () {
      var config = { childList: true, subtree: true };

      var callback = function (mutationsList, observer) {
        var prevExists = $('.cbb-also-bought-prev').length > 0;
        var nextExists = $('.cbb-also-bought-next').length > 0;

        if (prevExists || nextExists) {
          applyAttributes();
          observer.disconnect();
        }
      };

      var observer = new MutationObserver(callback);
      observer.observe(document.body, config);
    })();

    (function () {
      function addAriaAttributes() {
        $('.message.success, .message.error').attr({
          'aria-atomic': 'true',
          'aria-live': 'polite'
        });
      }

      function insertMessage() {
        const wizardHeader = document.querySelector('.action.submit');
        if (wizardHeader) {
          const messageDiv = document.createElement('div');
          messageDiv.className = 'missing_req-fields';
          messageDiv.setAttribute('aria-atomic', 'true');
          messageDiv.setAttribute('aria-live', 'polite');
          messageDiv.textContent =
            'The form has not been submitted because some required fields are missing. Please return to the top of the form and fill in each required field sequentially to submit the form.';

          wizardHeader.after(messageDiv);

          setTimeout(() => {
            messageDiv.style.display = 'none';
          }, 10000);
        }
      }

      function observeChanges() {
        const config = { attributes: true, childList: true, subtree: true };
        const observerCallback = function (mutationsList, observer) {
          mutationsList.forEach(mutation => {
            if (mutation.type === 'childList' && $('.globo-formbuilder').length) {
              addAriaAttributes();
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const target = mutation.target;
              if (target.classList.contains('panel') && target.classList.contains('errors')) {
                observer.disconnect();
                insertMessage();
              }
            }
          });
        };

        const observer = new MutationObserver(observerCallback);
        observer.observe(document.body, config);

        const submitButton = document.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.addEventListener('click', () => {
            observer.observe(document.body, config);
          });
        }
      }

      observeChanges();
    })();

    (function () {
      const menuBtn = document.getElementById('menu-btn');
      const navDrawer = document.getElementById('NavDrawer');
      const closeBtn = document.getElementById('menu-close-btn');
      const body = document.body;

      if (!menuBtn || !navDrawer || !closeBtn) return;

      const toggleMenu = (show, returnFocus = true) => {
        if (show) {
          navDrawer.style.display = 'block';
          menuBtn.setAttribute('aria-expanded', 'true');
          navDrawer.setAttribute('aria-hidden', 'false');
          body.classList.add('menu-active');
          setTimeout(() => {
            navDrawer.focus();
          }, 100);
        } else {
          navDrawer.style.display = 'none';
          menuBtn.setAttribute('aria-expanded', 'false');
          navDrawer.setAttribute('aria-hidden', 'true');
          body.classList.remove('menu-active');

          if (returnFocus) {
            setTimeout(() => {
              menuBtn.focus();
            }, 100);
          }
        }
      };

      menuBtn.addEventListener('click', (event) => {
        event.stopPropagation();
        const isExpanded = menuBtn.getAttribute('aria-expanded') === 'true';
        toggleMenu(!isExpanded);
      });

      closeBtn.addEventListener('click', () => {
        toggleMenu(false);
      });

      navDrawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          toggleMenu(false);
        }
      });

      document.addEventListener('click', (event) => {
        const isClickInsideMenu = navDrawer.contains(event.target);
        const isClickInsideMenuBtn = menuBtn.contains(event.target);

        if (!isClickInsideMenu && !isClickInsideMenuBtn) {
          toggleMenu(false, false);
        }
      });

      navDrawer.setAttribute('aria-hidden', 'true');
      navDrawer.setAttribute('tabindex', '-1');
      menuBtn.setAttribute('aria-expanded', 'false');
    })();

    (function () {
      if (window.innerWidth > 950) {
        const mobileMenu = document.querySelector('#menubtnskip');
        if (mobileMenu) {
          mobileMenu.remove();
        }
      }
    })();

    (function () {
      var originalTitle = document.title;
      var attentionTitle = '🔥 Great Prices on Top Brands';
      var titleSwitcher;

      window.addEventListener('blur', function () {
        titleSwitcher = setInterval(function () {
          document.title = (document.title === originalTitle) ? attentionTitle : originalTitle;
        }, 1000);
      });

      window.addEventListener('focus', function () {
        clearInterval(titleSwitcher);
        document.title = originalTitle;
      });
    })();

  });

})(jQuery);
document.addEventListener("DOMContentLoaded", function () {
  const freeShippingThreshold = 195; // Free shipping at $195 (Shopify handles shipping rule)
  const minimumCartValue = 50;       // Show bar at $50+
  let lastCartTotal = null;

  const bar = document.getElementById("free-shipping-bar");
  const shippingMessage = document.getElementById("shipping-message");
  const progressBar = document.getElementById("progress-bar");

  // If markup isn't present on this page, safely exit
  if (!bar || !shippingMessage || !progressBar) return;

  function throttle(fn, wait) {
    let timeoutId = null;
    let lastCallTime = 0;
    let lastArgs, lastThis;

    return function throttled(...args) {
      const now = Date.now();
      const remaining = wait - (now - lastCallTime);

      lastArgs = args;
      lastThis = this;

      if (remaining <= 0) {
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }
        lastCallTime = now;
        fn.apply(lastThis, lastArgs);
      } else if (!timeoutId) {
        timeoutId = setTimeout(function () {
          lastCallTime = Date.now();
          timeoutId = null;
          fn.apply(lastThis, lastArgs);
        }, remaining);
      }
    };
  }

  function updateFreeShippingBar() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const cartTotal = cart.total_price / 100;

        // Skip DOM updates if total hasn't changed
        if (cartTotal === lastCartTotal) return;
        lastCartTotal = cartTotal;

        // Hide bar until minimum cart value
        if (cartTotal < minimumCartValue) {
          bar.style.display = "none";
          return;
        }

        const amountLeft = freeShippingThreshold - cartTotal;
        const progress = (cartTotal / freeShippingThreshold) * 100;

        const message =
          amountLeft > 0
            ? `You're $${amountLeft.toFixed(2)} away from FREE SHIPPING!*`
            : "🎉 FREE SHIPPING UNLOCKED!*";

        shippingMessage.innerText = message;
        progressBar.style.width = `${progress > 100 ? 100 : progress}%`;
        bar.style.display = "block";

        // Optional: only if your CSS includes this class
        progressBar.classList.toggle("free-shipping-reached", amountLeft <= 0);
      })
      .catch((err) => console.error("Cart fetch error:", err));
  }

  const throttledUpdate = throttle(updateFreeShippingBar, 1000);

  function monitorCartChanges() {
    if (!window.fetch) return;

    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      const url =
        typeof input === "string" ? input : (input && input.url) || "";

      return originalFetch.call(this, input, init).then((response) => {
        // Update after cart-related requests
        if (url.includes("/cart")) throttledUpdate();
        return response;
      });
    };

    // Theme/app custom events (if present)
    document.addEventListener("cart:updated", throttledUpdate);
    document.addEventListener("ajaxCart:updated", throttledUpdate);
    document.addEventListener("cart:change", throttledUpdate);
  }

  // Initial load + listeners
  updateFreeShippingBar();
  monitorCartChanges();
});